import { render, staticRenderFns } from "./ChannelAccess.vue?vue&type=template&id=0f48f872&scoped=true"
import script from "./ChannelAccess.vue?vue&type=script&lang=js"
export * from "./ChannelAccess.vue?vue&type=script&lang=js"
import style0 from "./ChannelAccess.vue?vue&type=style&index=0&id=0f48f872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48f872",
  null
  
)

export default component.exports